import api from './api';

export const getEmployeeNumberingSettings = () => api.get('/v1/employee-numbering-settings');
export const updateEmployeeNumberingSettings = (data) => api.put('/v1/employee-numbering-settings', data);
